import { CanActivateFn } from '@angular/router';
import { createIdentityGuard } from './guard-factories';

export const internalUserAuthGuard: CanActivateFn = createIdentityGuard(
  authService => authService.getIsAuthedInternalUserWhenReady()
);
